import {
  SmartTextRegenerateResultRequest,
  SmartTextResponse,
  SmartTextResultResponse,
} from 'api/core';
import { useRegenerateSmartTextResult } from 'api/useSmartTextApi';
import { useForm } from 'react-hook-form';

interface SmartTextRegenerateFormProps {
  smartText: SmartTextResponse;
  smartTextResult: SmartTextResultResponse;
  onSuccess: () => void;
  onCancel: () => void;
}

export const SmartTextRegenerateForm = ({
  smartText,
  smartTextResult,
  onSuccess,
  onCancel,
}: SmartTextRegenerateFormProps) => {
  const {
    mutateAsync: regenerateTextEntryAsync,
    isPending: isPendingRegenerate,
  } = useRegenerateSmartTextResult();

  const { register, handleSubmit } = useForm<SmartTextRegenerateResultRequest>({
    defaultValues: {
      smartTextId: smartText.id,
      smartTextFormatId: smartTextResult.format.id,
      feedback: '',
    },
  });

  const onSubmit = handleSubmit(async (result) => {
    await regenerateTextEntryAsync({
      smartTextRegenerateResultRequest: result,
    });
    onSuccess?.();
  });

  return (
    <form onSubmit={onSubmit} className="space-y-2">
      <div className="form-control">
        <label className="label">
          <span className="label-text">Feedback</span>
        </label>
        <textarea
          className="textarea textarea-bordered"
          placeholder="Teksten skal være mere venlig og bruge emojis"
          maxLength={1024}
          {...register('feedback', {
            required: true,
            maxLength: 1024,
          })}
        />
      </div>

      <div className="flex justify-center space-x-4 pt-4">
        <button className="btn btn-primary" disabled={isPendingRegenerate}>
          Opret ny boligtekst
        </button>
        <button type="button" className="btn" onClick={onCancel}>
          Annuller
        </button>
      </div>
    </form>
  );
};
